import React from "react";
import { useFunnel } from "../../context/FunnelContext";
import { SingleSelect } from "./common/SingleSelect";

const getPersonalizedContent = (gender, age) => {
  let title = "Let's talk about your lifestyle";
  let subtitle;

  if (gender === "woman") {
    if (age >= 20 && age <= 29) {
      subtitle =
        "Women in their 20s have unique needs. Let's understand your current habits so we can help you hit your goals safely and effectively.";
    } else if (age >= 30 && age <= 39) {
      subtitle =
        "Women in their 30s often juggle multiple responsibilities. Let's create a plan that fits your busy lifestyle.";
    } else if (age >= 40) {
      subtitle =
        "As women age 40+, metabolism and nutritional needs change. Let's build a plan that supports your health goals.";
    }
  } else if (gender === "man") {
    if (age >= 20 && age <= 29) {
      subtitle =
        "Men in their 20s often focus on building strength and fitness. Let's create a plan that maximizes your potential.";
    } else if (age >= 30 && age <= 39) {
      subtitle =
        "For men in their 30s, balancing work and wellness is key. Let's develop habits that support your goals.";
    } else if (age >= 40) {
      subtitle =
        "Men 40+ have specific health considerations. Let's design a plan that maintains your vitality and strength.";
    }
  }

  // Default subtitle if no specific conditions are met
  if (!subtitle) {
    subtitle =
      "Understanding your current lifestyle helps us create a more personalized plan for you.";
  }

  return {
    title,
    subtitle,
  };
};

const calculateAge = (birthday) => {
  const birthDate = new Date(birthday);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export function LifestyleAssessment({ config }) {
  const { state } = useFunnel();
  const age = calculateAge(state.userData.birthday);
  const content = getPersonalizedContent(state.userData.gender, age);

  // Create a new config object with personalized content
  const personalizedConfig = {
    ...config,
    title: content.title,
    subtitle: content.subtitle,
  };

  return <SingleSelect config={personalizedConfig} />;
}
